import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import CreateMeeting from "../../../components/Meetings/CreateMeeting/Create";
import { mapDispatchToProps } from "../../../store/helpers/mapDispatch";
import { mapStateToProps } from "../../../store/helpers/mapState";
import { findDuplicates } from "../../../helpers/ObjectExist";
import { formValidtion } from "./validation";

const Create = (props) => {
  const {
    errorMessage,
    initialState,
    GetFormFields,
    ExportParticipantsFormat,
    ScheduleMeeting,
    loggedUser,
    rooms,
    GetAvailableRooms,
    GetEmployees,
    settings,
    CreateRoom,
    CreateDraft,
    location,
    draft,
    DraftDetails,
    DeleteDraft,
    ListAllProjects,
    projects,
    GetAllResources,
    resources,
    systemSettings
  } = props;
  const [selectedEmployees, setSelectedEmployees] = React.useState(
    []
  );
  const [loading, setLoading] = React.useState(false);
  const [validationMessage, setValidationMessage] = React.useState();
  const [formIsValid, setFormIsValid] = React.useState();
  const [field, setField] = React.useState("");
  const [info, setInfo] = React.useState();

  useEffect(() => {
    const validationProps = {
      ...info,
      setFormIsValid,
      setValidationMessage,
      setField,
    };
    formValidtion(validationProps);
  }, [field]);

  //close load 
  useEffect(() => {
    if (errorMessage) setLoading(false);
  }, [errorMessage]);

  useEffect(() => {
    if (info?.start && info?.end) {
      const start = info?.start;
      const end = info?.end;
      GetAvailableRooms(start, end);
    }
  }, [GetAvailableRooms, info?.start, info?.end]);



  useEffect(() => {
    GetAvailableRooms(info?.start);
    ListAllProjects();
    GetAllResources();
  }, [])
  useEffect(() => {
    if (location?.state?.draftId) {
      DraftDetails({ id: location?.state?.draftId });
    }
  }, []);
  useEffect(() => {
    if (location?.state?.draftId) {
      setSelectedEmployees(draft?.draft?.selectedEmployees ?? []);
      setInfo({
        ...info, agenda: draft?.draft?.agenda, reminder: draft?.draft?.reminder,
        start: draft?.draft?.start, end: draft?.draft?.end, roomId: draft?.draft?.room, name: draft?.draft?.name, type: draft?.draft?.type, venue: draft?.draft?.venue
      })
    }
  }, []);

  // submit schedule meeting
  const onSubmit = async (partcpants, duration) => {
    let participantsData = [];
    const duplicateParticipants = findDuplicates(participantsData);
    if (formIsValid) {
      const newInfo = {
       ...info,
       duration,
        participants: selectedEmployees,
      };
      if (location?.state?.draftId) {
        DeleteDraft(location?.state?.draftId);
      }
      await ScheduleMeeting(newInfo);
    }
  };

  // submit schedule draft
  const onSubmitDraft = (partcpants, duration) => {
    const data = {
      draft: {
       ...info,
       duration,
        selectedEmployees,
        partcpants,
      },
      id: location?.state?.draftId,
      type: "meeting",
    };

    CreateDraft(data, "meetings");
  };
  return (
    <div className="w-full mb-12 px-4">
      <ToastContainer />
      <CreateMeeting
        info={info}
        setInfo={setInfo}
        draft={draft}
        onSubmitDraft={onSubmitDraft}
        createRoom={async (room) => {
          const data = await CreateRoom(room);
          if (data) {

            GetAvailableRooms(info?.start);
          }
          return data;
        }}
        settings={settings}
        GetEmployees={GetEmployees}
        setSelectedEmployees={setSelectedEmployees}
        initialState={initialState}
        ExportFormat={ExportParticipantsFormat}
        GetFormFields={GetFormFields}
        rooms={rooms}
        onSubmit={onSubmit}
        loggedUser={loggedUser}
        selectedEmployees={selectedEmployees}
        setLoading={setLoading}
        loading={loading}
        validationMessage={validationMessage}
        field={field}
        errorMessage={errorMessage}
        setField={setField}
        projects={projects}
        GetAllResources={GetAllResources}
        resources={resources?.data}
        systemSettings={systemSettings}
      />
    </div>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(Create);
